import * as t from "io-ts";
import * as CaseDocument4 from "./CaseDocument4";

export const codec = t.type({
    ...CaseDocument4.codec.props,
    reference: t.string,
});

export type T = t.TypeOf<typeof codec>;
